import { LP_BUILDER_FORM_MODE, LpBuilderFormMode } from '../constants';
import * as Yup from 'yup';

export const getValidationSchema = (mode: LpBuilderFormMode) => {
  return Yup.object({
    uiKits: Yup.array().of(
      Yup.object({
        title: Yup.string()
          .required('Title is required')
          .max(80, 'Title must be at most 80 characters')
          .test(
            'not-just-spaces',
            'Please enter a valid title',
            value => !value || value.trim().length > 0
          ),
        thumbnail: Yup.object({
          url: Yup.string().required('Thumbnail is required'),
        }).required('Thumbnail is required'),
      })
    ),

    title: Yup.string().when([], {
      is: () => mode !== LP_BUILDER_FORM_MODE.BULK_EDIT,
      then: (schema: Yup.StringSchema) =>
        schema
          .required('Title is required')
          .max(80, 'Title must be at most 80 characters')
          .test(
            'not-just-spaces',
            'Please enter a valid title',
            value => !value || value.trim().length > 0
          ),
      otherwise: (schema: Yup.StringSchema) => schema.strip(true), // removes it when in BULK_EDIT
    }),
  });
};
